module.exports = __webpack_public_path__ + "static/media/close-icon.e670c4e6.svg";